// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox__checkbox___S1u8F"};